bq.payInvoice = function(element, options) {
    this.options   = options;
    this.eventsCreated = false;
    this.$element  = $(element);
    this.$wrapper  = false;
    this.$addInvoicesButton = false;
    this.$listingContainer = false;
    this.$actionButtons = false;
    this.gridsUpdated = 0;
    this.processingGrids = 0;
    this.keepInvoicesChecked = true;
};

bq.payInvoice.DEFAULTS = {
    wrapper: '.invoices-grid-wrapper',
    selectedInvoicesContainer: '.selected-invoices-container',
    actionButtons: '.batch-container-buttons',
    submitBatchForm: '#bqat-frmSubmitBatch',
    listingContainer: '.listing-container',
    addInvoicesButton: '[data-action-add=""]',
    addInvoicesCheckbox: '[name="add_invoice[]"], [name="add_invoice"]',
    addInvoicesTopCheckbox: '[name="add_invoice"]',
    checkedInvoicesSelector: '[name="add_invoice[]"]:checked'
};

bq.payInvoice.prototype = {
    init: function() {
        bq.debug.log("Pay Invoice : init()", this.$element);
        this.$wrapper = $(this.options.wrapper);
        this.$addInvoicesButton = $(this.options.addInvoicesButton);
        this.$addInvoicesTopCheckbox = $(this.options.addInvoicesTopCheckbox);
        this.$listingContainer = $(this.options.listingContainer);
        this.$selectedInvoicesContainer = $(this.options.selectedInvoicesContainer);
        this.$actionButtons = $(this.options.actionButtons);
        if(!this.eventsCreated) {
            this.$element.on('click', '[data-action-remove-all], [data-action-remove], [data-action-add]', {context:this}, this._catchDataActionEvent);
            this.$element.on('change', this.options.addInvoicesCheckbox, {context:this}, this._catchCheckboxChangeAction);
            this.$element.on('keydown', '[name*=net_amount]', {context:this}, this._catchNetAmountEvent);
            this.$listingContainer.on('bq.itemListing.loadStart', {context: this}, this._countUpdatedGrids);
            this.$listingContainer.on('bq.itemListing.loadEnd', {context: this}, this._catchGridUpdate);
            this.$listingContainer.on('bq.pagination.changed', {context: this}, this._catchPaginationChanged);
            this.eventsCreated = true;
            $(this.options.submitBatchForm).on('submit', {context: this}, this._catchSubmitForm);
            $(window).on('load', {context: this}, this._catchWindowLoad);
        }

        this.keepInvoicesChecked = this.$listingContainer.data('keepInvoicesChecked');
        this._updateGrids = this._updateGrids.bind(this);
        this._successCallback = this._successCallback.bind(this);
        this._errorCallback = this._errorCallback.bind(this);
        this._catchCheckboxChangeAction = this._catchCheckboxChangeAction.bind(this);
    },

    _handleBeforeUnload: function (e) {
        e.preventDefault();
        e.returnValue = '';
    },

    _processRemove: function(element) {
        this.request(element.attr('href'), {}, this._successCallback, this._errorCallback);
    },

    _processRemoveAll: function(element) {
        this.request(element.data('url'), {}, this._successCallback, this._errorCallback);
    },

    _processInvoices: function(element) {
        var invoices = this._getSelectedInvoices();
        var data = {'selected_invoices': invoices};
        this.request(element.data('url'), data, this._successCallback, this._errorCallback);
    },

    _countUpdatedGrids: function(e) {
        var $this = e.data.context;
        $this.processingGrids++;
    },

    _catchGridUpdate: function(e) {

        var $this = e.data.context;
        $this.gridsUpdated++;
        if ($this.processingGrids === $this.gridsUpdated) {
            $this._throwEventLoadEnd();
            $this.gridsUpdated = 0;
            $this.processingGrids = 0;
        } else {
            $this._throwEventLoadStart();
        }
    },

    _catchPaginationChanged: function(e) {
        var $this = e.data.context;
        if ($this.keepInvoicesChecked) {
            return;
        }

        $($this.options.addInvoicesCheckbox).each(function() {
            var $el = $(this);
            $el.prop('checked', false);
        });
    },

    _updateGrids: function() {
        this.$addInvoicesButton.prop('disabled', true);
        $(this.options.listingContainer).each(function() {
            var $el = $(this);
            $el.triggerHandler('bq.grid.changed');
        });
    },

    _catchDataActionEvent: function(e) {
        e.preventDefault();
        var $this = e.data.context,
            $el = $(e.currentTarget);

        $this._throwEventLoadStart();

        if ($el.data('actionRemove') === '') {
            $this._processRemove($el);
        } else if($el.data('actionRemoveAll') === '') {
            $this._processRemoveAll($el);
        } else if($el.data('actionAdd') === '') {
            $this._processInvoices($el);
        }
    },

    _catchWindowLoad: function(e) {
        var $this = e.data.context;
        window.addEventListener('beforeunload', $this._handleBeforeUnload);
        $this.$addInvoicesButton.prop('disabled', !$this._getSelectedInvoices().length);
    },

    _catchSubmitForm: function(e) {
        var $this = e.data.context;
        e.preventDefault();
        window.removeEventListener("beforeunload", $this._handleBeforeUnload);
        this.submit();
    },

    _catchNetAmountEvent: function(e) {
        var key = e.charCode || e.keyCode || 0;
        // allow to enter only digits and decimals
        return (
            key == 8 ||
            key == 9 ||
            key == 13 ||
            key == 46 ||
            key == 110 ||
            key == 190 ||
            (key >= 35 && key <= 40) ||
            (key >= 48 && key <= 57) ||
            (key >= 96 && key <= 105));
    },

    request: function(url, data, successCallback, errorCallback) {
        $.ajax({
            type: 'post',
            url: url,
            data: data,
            success: function (response) {
                var json = JSON.parse(response);

                if (json['redirect']) {
                    window.removeEventListener("beforeunload", this._handleBeforeUnload);
                    window.location.href = json['redirect'];
                    return;
                }

                if (json['error'] === true) {
                    errorCallback(json['message']);
                } else {
                    successCallback(json['message'], json['hasItems']);
                }

            }.bind(this)
        });
    },

    _throwEventLoadStart: function() {
        bq.helper.throwEvent('bq.viewhandler.start', this.$wrapper)
    },

    _throwEventLoadEnd: function() {
        bq.helper.throwEvent('bq.viewhandler.stop', this.$wrapper)
    },

    _successCallback: function(message, hasItems) {
        if (typeof hasItems === 'undefined') {
            hasItems = false;
        }

        if (hasItems) {
            this.$actionButtons.removeClass('hide');
            this.$selectedInvoicesContainer.find('thead .headings').removeClass('hide');
        } else {
            this.$actionButtons.addClass('hide');
            this.$selectedInvoicesContainer.find('thead .headings').addClass('hide');
        }

        this._updateGrids();
        this.$addInvoicesTopCheckbox.prop('checked', false);
        this._catchSuccessMessage(message);
    },

    _errorCallback: function(message) {
        this._catchErrorMessage(message);
        this._throwEventLoadEnd();
    },

    _catchErrorMessage: function(message) {
        bq.helper.throwEvent('bq.notification', $(document), {
            id: 'notification_bq-ui-invoices-batch',
            text: message,
            type: 'error'
        });
    },

    _catchCheckboxChangeAction: function(e) {
        var $this = e.data.context;
        $this.$addInvoicesButton.prop('disabled', !$this._getSelectedInvoices().length);
    },

    _catchSuccessMessage: function(message) {
        bq.helper.throwEvent('bq.notification', $(document), {
            id: 'notification_bq-ui-invoices-batch',
            text: message,
            type: 'success'
        });
    },

    _getSelectedInvoices: function() {
        return $(this.options.checkedInvoicesSelector).map(function (_,el) {
            return el.value;
        }).get();
    }
};

// PAY INVOICES PLUGIN DEFINITION
// =======================

var payInvoiceOld = $.fn.payInvoice;

$.fn.payInvoice = function (option, _relatedTarget) {
    return this.each(function () {
        var $this   = $(this);
        var data    = $this.data('bq.payInvoice');
        var options = $.extend({}, bq.payInvoice.DEFAULTS, $this.data(), typeof(option) === 'object' && option);

        if (!data) { $this.data('bq.payInvoice', (data = new bq.payInvoice(this, options))); }
        data.init();
    });
};

$.fn.payInvoice.Constructor = bq.payInvoice;

// PAY INVOICES NO CONFLICT
// =================

$.fn.payInvoice().noConflict = function () {
    $.fn.payInvoice = payInvoiceOld();
    return this;
};

// PAY INVOICES DATA-API
// ==============

bq.payInvoicesInit = function() {
    $('[data-bq="payInvoices"]').each(function () {
        var $el = $(this);
        $el.payInvoice($el.data());
    });
};

bq.init.push(bq.payInvoicesInit);